import { useEffect, type ReactNode } from 'react';
import { IconButton } from './IconButton';

export type ModalProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  width?: number;
  children: ReactNode;
};

export function Modal({ open, onClose, title, width, children }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal"
        style={{ maxWidth: width ?? 640 }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        {title && (
          <div className="card-header">
            <h3 className="card-title">{title}</h3>
            <IconButton name="x" onClick={onClose} label="Close" />
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
